import { render, staticRenderFns } from "./ContactCardField.vue?vue&type=template&id=897e6164&"
import script from "./ContactCardField.vue?vue&type=script&lang=ts&"
export * from "./ContactCardField.vue?vue&type=script&lang=ts&"
import style0 from "./ContactCardField.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports